import { render, staticRenderFns } from "./cadastro.vue?vue&type=template&id=cfa2868a&scoped=true&"
import script from "./cadastro.vue?vue&type=script&lang=js&"
export * from "./cadastro.vue?vue&type=script&lang=js&"
import style0 from "./cadastro.vue?vue&type=style&index=0&id=cfa2868a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa2868a",
  null
  
)

export default component.exports